import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { productAPI } from '../services/api';

const normalizeImageUrl = (url) => {
  if (!url) return '';
  const value = String(url).trim();
  if (!value) return '';

  const safeValue = value
    .replace(/\.heic(?=[?#]|$)/gi, '.jpg')
    .replace(/\.heif(?=[?#]|$)/gi, '.jpg');

  if (safeValue.includes('cloudinary.com') && !/[?&]fm=jpg/i.test(safeValue)) {
    return `${safeValue}${safeValue.includes('?') ? '&' : '?'}fm=jpg`;
  }

  return safeValue;
};

export default function HomeLegacy() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    productAPI.getNewProducts()
      .then((response) => setProducts(response.data.products || []))
      .catch((error) => console.error('Error fetching products:', error))
      .finally(() => setLoading(false));
  }, []);

  const formatPrice = (value) => new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0
  }).format(value || 0);

  if (loading) return <div className="page-loading">Loading products...</div>;

  return (
    <div className="home-page">
      <section className="hero-banner">
        <div className="hero-content">
          <span className="eyebrow">Made for their moments</span>
          <h1>Little Looks, Big Memories</h1>
          <p>Discover thoughtfully designed outfits for birthdays, celebrations, and every picture-perfect moment.</p>
          <div className="hero-actions">
            <button onClick={() => navigate('/shop')}>Shop the Collection</button>
            <button className="secondary" onClick={() => navigate('/contact')}>Explore New Arrivals</button>
          </div>
        </div>
      </section>
      <section className="products-section">
        <div className="section-header"><div><span className="section-kicker">New arrivals</span><h2>Exquisite Masterpieces</h2></div></div>
        <div className="product-grid">
          {products.length === 0 ? <div className="empty-state">No products available yet.</div> : products.map((product) => {
            const image = normalizeImageUrl(product.images?.find((item) => item.isPrimary)?.url || product.images?.[0]?.url);
            return (
              <div key={product._id} className="product-card" onClick={() => navigate(`/product/${product._id}`)}>
                <div className="product-image-wrap"><img src={image} alt={product.name} className="product-image" /></div>
                <div className="product-body"><div className="product-meta">{product.isNew && <span className="badge">New</span>}</div><h3>{product.name}</h3><span className="price">{formatPrice(product.price)}</span></div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}